<div [class.hidden]="hidden">
  <div class="form-wrapper" [class.inline]="formInline">
    <div class="toggle-wrapper" data-test-id="toggle-component.wrapper">
      <ion-toggle
        #toggle
        [disabled]="readonly"
        [formControl]="control"
        [class.error]="showError && control?.errors && control?.touched"
        [value]="value"
        color="primary"
        >
      </ion-toggle>
      <c-spinner [loading]="loading"></c-spinner>
    </div>
    <div class="labels">
      @if (label) {
        <ion-label
          [ngClass]="{ uppercase: uppercase }"
          [color]="readonly ? 'medium' : null"
          class="ion-text-start label"
          >
          {{ label | transloco }}
          @if (labelLinkTxt && labelLink) {
            <a [routerLink]="['/' + labelLink]">
              {{ labelLinkTxt | transloco }}
            </a>
          }
        </ion-label>
      }
      @if (subLabel !== '') {
        <div class="sub-label">{{ subLabel | transloco }}</div>
      }
    </div>
  </div>
</div>

@if (showError && control?.errors && control?.touched) {
  <div
    class="error-wrapper"
    [class.absolute]="errorPlacement === 'absolute'"
    [class.inline]="inline"
    >
    @if (inline) {
      <div class="clear"></div>
    }
    <c-validation-error [validationMessages]="control?.errors" [controlValue]="control?.value"> </c-validation-error>
  </div>
}

@if (info) {
  <div class="info" [class.inline]="inline">
    @if (inline) {
      <div class="clear"></div>
    }
    <div>{{ info | transloco }}</div>
  </div>
}
